export default {
  loading: (state) => state.loading,
  quotaInformation: (state) => state.quotaInformation
}
